// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__AbK0Y","trigger":"tooltip_trigger__lSaqS","content":"tooltip_content__4wnnX"};